import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../../services/login.service';
import { ModelService } from '../../../services/model.service';
import { GlobalService } from '../../../services/global.service';
import { AlertsService } from '../../../services/alerts.service';

@Component({
  selector: 'app-confirm-registration',
  templateUrl: './confirm-registration.component.html',
  styleUrls: ['./confirm-registration.component.css']
})
export class ConfirmRegistrationComponent implements OnInit {

  newPassword:     string = '';
  confirmPassword: string = '';

  isSubmitButtonDisabled: boolean = false;
  isAvailable: boolean = true;

  constructor ( 
    private model: ModelService,
    public global: GlobalService,
    private alerts: AlertsService,
    private loginService: LoginService ) {
    if ( this.loginService.userInfo.status == 'active' && this.loginService.userInfo.fresh_login == 1 ) this.isAvailable = true;
    else {
        this.isAvailable = false;
        this.global.redirect( '/' );
    }
  }

  ngOnInit ( ) {
  }

  successCallback ( ) {
    this.loginService.isLogged = false;
    localStorage.removeItem( 'currentUser' );
    this.global.defaultSuccessMessage({ 
      html: 'Your password has been changed successfully. <br />Use it to login again', 
      redirect: '/login' 
    });
  }

  errorCallback ( message? ) {
    let _message = ( message ) ? message : 'We got some error here';
    let data = {
      messageType: 'error',
      message: _message,
      title: ''
    }
    this.alerts.setData( data ).subscribe( );
    this.global.defaultErrorCallback( message, false );
    this.isSubmitButtonDisabled = false;

  }

  errorPasswords ( ) {
    let data = {
      messageType: 'error',
      message: 'Passwords don\'t match',
      title: ''
    }
    this.alerts.setData( data ).subscribe( );
    this.global.defaultErrorCallback( 'Passwords don\'t match', false );
    this.isSubmitButtonDisabled = false;
  }


  submitForm ( ) {

    this.isSubmitButtonDisabled = true;
    if ( this.newPassword != this.confirmPassword ) {
        this.errorPasswords( );
    } else {
        this.model.changePassword( this.newPassword, ( response ) => {
          let _answer = response.json( );
          _answer = _answer.answer;
          if ( _answer == 'success' ) this.successCallback( );
          else {
            this.errorCallback( _answer );
          }
        });
    }
    return false;
  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/defaults/confirm-registration/confirm-registration.component.ts